import PropTypes from 'prop-types'
import ContextMenuComponent from '../../../components/stories/organisms/context-menu'
import FeatureAvailability from '../../FeatureAvailability'
import FeatureBadge from '../../FeatureAvailability/components/FeatureBadge'

// A context menu item gated by the organisation's tier. FeatureAvailability
// renders the item untouched when the feature is available; when it is not it
// wraps the item, adds the tier badge and captures the click to open the
// upgrade dialog — so the item's own onClick only ever runs for users who
// actually have the feature.
const PlanMenuContextMenuFeatureItem = ({ featureSlug, ...itemProps }) => (
  <FeatureAvailability
    key={featureSlug}
    featureSlug={featureSlug}
    render={({ isDisabled, requiredTier, loading, error }) => (
      <ContextMenuComponent.Item
        {...itemProps}
        disabled={itemProps.disabled || isDisabled()}
        badge={
          isDisabled() ? (
            <FeatureBadge tier={requiredTier} loading={loading} error={error} />
          ) : null
        }
      />
    )}
  />
)

PlanMenuContextMenuFeatureItem.propTypes = {
  featureSlug: PropTypes.string.isRequired,
  disabled: PropTypes.bool
}

export default PlanMenuContextMenuFeatureItem
